export interface SelectedFields {
  // Essentials
  name: boolean;
  formattedAddress: boolean;
  addressComponents: boolean;
  location: boolean;
  googleMapsUri: boolean;
  // Contact
  internationalPhoneNumber: boolean;
  websiteUri: boolean;
  // Atmosphere
  rating: boolean;
  userRatingCount: boolean;
  businessStatus: boolean;
  regularOpeningHours: boolean;
  parkingOptions: boolean;
}

export type SkuTier = "basic" | "contact" | "atmosphere";

/**
 * デフォルトで選択されるフィールド（必須項目のみ）
 * - スポット編集画面の「Google詳細情報取得」モーダル
 * - スポット新規作成（地図検索）のStep 2
 */
export const DEFAULT_REQUIRED_FIELDS: SelectedFields = {
  // Essentials - 必須項目
  name: true,
  formattedAddress: true,
  addressComponents: true,
  location: true,
  googleMapsUri: true,
  // Contact
  internationalPhoneNumber: false,
  websiteUri: false,
  // Atmosphere - 必須項目
  rating: true,
  userRatingCount: true,
  businessStatus: true,
  regularOpeningHours: false,
  parkingOptions: false
};
